const $$splitPendingComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/content.$postId.tsx?tsr-split=pendingComponent');
const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/content.$postId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { ZnglyVideosFrontendQuery, type ZnglyVideos_Frontend_Pagination_Fragment$key, type ZnglyVideos_Frontend_Query } from '@/graphql/queries/ZnglyVideo.query';
import { RelayEnvironment } from '@/graphql/relay-env';
import { usePaginationFragment } from '@/graphql/relay.utils';
import { useAppStore } from '@/inertia/AppStore';
import { createFileRoute } from '@tanstack/react-router';
import { loadQuery } from 'react-relay';
import { z } from 'zod';
type Props = {
  isFallback?: boolean;
} & Partial<ReturnType<typeof usePaginationFragment<ZnglyVideos_Frontend_Query, ZnglyVideos_Frontend_Pagination_Fragment$key>>>;
const searchSchema = z.object({
  c: z.string().optional().nullable().catch(null)
});
type SearchSchema = z.infer<typeof searchSchema>;
export const Route = createFileRoute('/content/$postId')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  validateSearch: (params): SearchSchema => searchSchema.parse(params),
  onEnter: () => {
    useAppStore.setState({
      barView: 'list',
      pageType: 'single',
      barTitle: 'Suggested Content'
    });
  },
  onLeave: () => {
    useAppStore.setState({
      catalogLoadMore: undefined,
      barView: 'list'
    });
  },
  pendingComponent: lazyRouteComponent($$splitPendingComponentImporter, 'pendingComponent'),
  loader: ({
    params
  }) => {
    return loadQuery<ZnglyVideos_Frontend_Query>(RelayEnvironment, ZnglyVideosFrontendQuery, {
      first: 24,
      where: {
        in: [params.postId],
        queryType: 'SINGLE'
      }
    }, {
      fetchPolicy: 'store-or-network'
    });
  }
});